import React, {useContext} from 'react';
import {Colours} from '../Colours';
import {Breakpoints, styled} from '@volkswagen-onehub/components-core';
import {
  ResultsView,
  ResultsViewContext,
} from '../../../utils/results-view-context';

interface CardColoursContainerInterface {
  sold?: boolean;
  view: ResultsView;
}

interface CardColoursInterface {
  sold?: boolean;
}

const CardColoursContainer = styled.div<CardColoursContainerInterface>`
  grid-area: colours;
  padding: ${(props) => props.theme.size.static150} 0;
  
  ${props => props.sold && `
    display: none;

    @media screen and (min-width: ${Breakpoints.b960}px) {
      display: ${props.view == ResultsView.GRID ? 'none' : 'block'};
    }
  `}

  ${(props) =>
    props.view == ResultsView.LIST &&
    `
    @media screen and (min-width: ${Breakpoints.b960}px) {
      border-bottom: none;
      padding: ${props.theme.size.dynamic0020} 0;
      margin: 0 24px;
    }
  `}
`;

const CardColours : React.FC<CardColoursInterface> = ({sold = false}) => {
  const view = useContext(ResultsViewContext).value;

  return (
    <CardColoursContainer view={view} sold={sold}>
      <Colours />
    </CardColoursContainer>
  );
};

export default CardColours;
